// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2NSDj","buttons":"SendReceipts_buttons__3gAHu","email":"SendReceipts_email__2IkUB","bookApptTitle":"SendReceipts_bookApptTitle__3Imsk"};